document.addEventListener("DOMContentLoaded", function() {

  const bloco = document.getElementById("personalizacao-bloco");

  if (!bloco) return;

  function normalizar(texto) {
    return texto
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  }

  function deveMostrar(valor) {
    if (!valor) return false;

    const texto = normalizar(valor);

    if (texto.includes("personalizar")) return true;
    if (texto.includes("personalizacao")) return true;
    if (texto.includes("sim")) return true;

    return false;
  }

  function verificarVarianteAtual() {

    const variantInput = document.querySelector('input[name="id"]');
    if (!variantInput) return;

    const variantId = variantInput.value;

    const variants = window.productVariants;

    if (!variants) return;

    const variantAtual = variants.find(v => v.id == variantId);
    if (!variantAtual) return;

    let textoCompleto = "";

    if (variantAtual.option1) textoCompleto += " " + variantAtual.option1;
    if (variantAtual.option2) textoCompleto += " " + variantAtual.option2;
    if (variantAtual.option3) textoCompleto += " " + variantAtual.option3;

    if (deveMostrar(textoCompleto)) {
      bloco.style.display = "block";
    } else {
      bloco.style.display = "none";
      document.getElementById("personalizacao-nome").value = "";
      document.getElementById("personalizacao-numero").value = "";
    }
  }

  document.addEventListener("change", function() {
    setTimeout(verificarVarianteAtual, 200);
  });

  setTimeout(verificarVarianteAtual, 1000);

});
